import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetTrackInfo = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/track_info/${uuid}`, 'GET', idToken)
}

export const UpdateTrackInfo = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/track_info/${uuid}`, 'PATCH', idToken, payload)
}

export const DeleteTrackInfo = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/track_info/${uuid}`, 'DELETE', idToken)
}
